/* @flow */
import React from 'react';

export const Illustration = (
	<g>
		<path
			fill="#fff"
			fillRule="evenodd"
			d="M156.242 17.5281c-21.659-2.0003-25.59 2.1728-27.832 6.4838-2.242 4.2937-3.742 17.0543-6.363 19.9169-2.604 2.8797-9.019 8.9151-9.019 8.9151l5.605 4.0524s-1.311 4.4145-1.811 5.4146c-.5 1.0002 4.363 2.4832 6.536 3.2936 2.19.8105 3.121 1.1899 3.121 1.1899s-4.742 2.2417-7.657 2.2417c-2.931 0-.81 4.0868-.81 4.0868s-3.001 8.5876-1.121 10.7776c1.862 2.1727 13.381 2.8625 15.744 6.4147 2.379 3.5523 1 20.9858 1 20.9858l31.643-3.362s-3.984-31.6432-.5-37.7476c4.604-8.0529 14.864-8.691 15.468-27.9698.327-10.8465-4.57-22.9001-24.004-24.6935Z"
			clipRule="evenodd"
		/>
		<path
			fill="#000"
			d="M129.819 46.6659c.034 1.1178.922 1.9518 1.985 1.8627 1.063-.089 1.897-1.0674 1.864-2.1852-.034-1.1179-.922-1.9519-1.985-1.8628-1.063.089-1.897 1.0674-1.864 2.1853Z"
		/>
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="M130.635 39.8076c2.828.1897 4.897.9829 7.277 2.4487"
		/>
		<path
			fill="#000"
			fillRule="evenodd"
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth=".755906"
			d="M122.513 17.1834s-4.949-.0345-3.087 3.9144c1.879 3.9489 11.864 3.9317 15.33 4.1731 3.449.2586 10.829 2.7763 10.829 2.7763s-3.638 1.207.31 3.4833c3.967 2.2762 5.363 3.6729 5.363 7.0355s-5.414 7.9495-4.983 10.5361c.431 2.5867.465 6.2596.431 8.122-.035 1.8624.966 1.8624 3.673-1.3623 2.724-3.2419 8.329-5.1215 10.933-.7587 2.621 4.3627-2.242 11.3983-5.105 13.64-2.862 2.2417-5.794 1.7417-5.794 1.7417s.38 14.3988 5.053 17.4509c4.673 3.0522 6.346-1.2588 6.346-1.2588s2.5 2.1211 5.483.069c2.984-2.052 4.863-12.7606 10.709-19.8651 5.863-7.1046 13.588-29.5219 7.363-41.4892-6.242-11.9501-29.78-16.93368-33.143-18.19249-3.363-1.24158-10.036-4.29377-17.313-6.1044-7.294-1.79338-7.036 1.25882-6.863 3.62125.19 2.36244 1.19 3.98338 1.19 3.98338s-6.156-2.12102-8.467 1.68996c-2.311 3.7936 1.742 6.7941 1.742 6.7941Z"
			clipRule="evenodd"
		/>
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="M151.189 67.0533s0-4.4145 2.121-7.8633c2.121-3.4661 5.174-3.5523 5.174-3.5523m-2.156 7.4663-3.552-2.9487"
		/>
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="M165.278 107.939s-.276-2.259-.638-5.656c-.948-9.3976-2.414-27.6074.138-32.0908 4.604-8.053 14.864-8.691 15.468-27.9699.328-10.8465-4.57-22.9001-24.004-24.6934-15.726-1.4485-22.107.3621-25.28 3.0867-1.189 1.0346-1.931 2.2072-2.552 3.397-2.241 4.2938-3.742 17.0544-6.363 19.9169-2.604 2.8798-9.018 8.9152-9.018 8.9152l5.604 4.0523s-1.311 4.4145-1.811 5.4147c-.5 1.0001 4.363 2.4831 6.536 3.2936 2.19.8104 3.121 1.1898 3.121 1.1898s-4.742 2.2417-7.656 2.2417c-2.932 0-.811 4.0869-.811 4.0869s-3 8.5875-1.121 10.7775c1.863 2.1728 13.382 2.8625 15.744 6.4148 2.38 3.5523 1 20.986 1 20.986"
		/>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="M129.513 18.3564c6.001.1208 12.278.5001 17.814 3.0522m-6.846-7.019c5.587.2932 10.519 2.0348 15.226 5.0526M139.222 7.52637c3.19 2.24172 5.346 2.86253 8.967 3.91443m17.882 29.6608s1.19 2.7418.931 6.4147c-.241 3.673-.931 4.8456-.931 4.8456m6.225-2.6734c-.069 3.4833-1.638 8.9324-3.121 12.0881m6.742-3.7759c1.863-3.8627 2.587-6.3631 2.863-11.1052"
		/>
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="M146.43 77.8828c-4.914 7.5184-13.553 9.1394-23.934 8.1737"
		/>
		<path
			fill="#000"
			fillRule="evenodd"
			d="m96.5085 108.576 4.6045-1.759s2.379-.707 3.328.81c.931 1.535-.242 3.277-1.897 4.156-1.638.862-4.2938 1.897-4.2938 1.897l-1.7417-5.104Z"
			clipRule="evenodd"
		/>
		<path
			fill="#fff"
			fillRule="evenodd"
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="m11.9602 80.0202 12.9503 89.9448 61.0439-13.709-9.967-88.7033-64.0272 12.4675Z"
			clipRule="evenodd"
		/>
		<path
			fill="#F1714E"
			fillRule="evenodd"
			d="m29.1008 72.9503 1.5003 9.1566 28.2802-5.7941-1.0174-8.8806-7.277 1.3967c-.776-1.1726-2.5004-2.6556-6.2941-2.4141-4.38.2759-6.5699 3.3281-7.4494 5.0525l-7.7426 1.483Z"
			clipRule="evenodd"
		/>
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="m30.6018 107.594 35.8159-8.3977M32.0491 114.905l35.7986-8.415m-34.4705 15.934 35.8159-8.415m-33.229 21.606L71.78 127.2m-35.2644 15.865 35.8159-8.416"
		/>
		<path
			stroke="#F1714E"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="m61.9336 148.427 12.3122-2.897M22.4963 92.5217l14.9851-3.5178m20.555-4.2245 10.0877-2.3624"
		/>
		<path
			fill="#fff"
			fillRule="evenodd"
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="M26.0319 137.753s-1.9314-10.829-.1207-16.623c1.7933-5.794 3.7937-15.83 1.4312-18.693-2.3624-2.8622-9.9843 15.072-9.9843 15.072L14.099 94.9189s-4.75937 3.9662-6.19063 6.6221c-1.43125 2.638-.93118 4.845-.93118 4.845s-2.43141 2.001-2.81078 3.587c-.36212 1.586.25867 3.087.25867 3.087s-1.84512 1.776-2.27622 3.793c-.4311 2.035.31039 3.311.31039 3.311s-1.534717 5.501.08622 11.174c1.62094 5.674 8.96693 18.365 8.96693 18.365l14.5195-11.95Zm82.1511-14.709s-21.6762-11.709-31.5053-15.192c-9.8464-3.484-13.209-2.552-13.209-2.552s-5.863.189-7.2252 2.983c-1.3796 2.811-1.3796 8.415-1.3796 8.415s-4.4144 6.484-4.4144 9.156c0 2.673 6.5355-1.207 6.5355-1.207s12.2087 4.104 17.2613 9.709c5.0352 5.604 14.1401 9.398 14.1401 9.398l19.7966-20.71Z"
			clipRule="evenodd"
		/>
		<path
			fill="#F1714E"
			fillRule="evenodd"
			d="m97.5946 106.955 2.5344 6.432-43.1614 19.296-2.19-6.294 42.817-19.434Z"
			clipRule="evenodd"
		/>
		<path
			fill="#000"
			fillRule="evenodd"
			d="m56.8121 132.287-8.4496.517 6.5528-5.966 1.8968 5.449Z"
			clipRule="evenodd"
		/>
		<path
			fill="#fff"
			fillRule="evenodd"
			d="M80.0394 126.32s-8.1909-1.19-11.381.224c-3.1729 1.397-7.5529.862-8.6221 2.293-1.0518 1.432-1.0174 4.053 3.3109 4.467 4.3283.396 8.4323-1.018 10.5878.724 2.1728 1.759 6.1044-7.708 6.1044-7.708Z"
			clipRule="evenodd"
		/>
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="M80.0394 126.32s-8.1909-1.19-11.381.224c-3.1729 1.397-7.5529.862-8.6221 2.293-1.0518 1.432-1.0174 4.053 3.3109 4.467 4.3283.396 8.4323-1.018 10.5878.724m-5.259-28.418c-8.0185.069-11.3121 6.967-13.8125 11.088m20.0894-.517-8.0702-2.363-9.8981 10.83m11.847-12.624-1.9485 1.794m-4.6045 8.14.1552-3.276m5.1387.826.069-5.466"
		/>
		<path
			fill="url(#a)"
			fillRule="evenodd"
			d="M64.7787 177.5s20.917-41.368 34.0052-53.077c13.0711-11.709 27.0211-16.934 58.3021-20.296 31.264-3.363 43.714 4.983 50.939 27.642 7.225 22.676-5.915 61.975-5.915 61.975l-.601 62.185c-.011 1.097-.903 1.98-2 1.98H90.3858c-1.1046 0-1.8525-.689-1.7166-1.785 1.0887-8.783 4.9415-45.429 4.9415-45.429s-8.1047 22.176-36.3677 12.83c-28.2802-9.347-41.9893-53.06-44.4724-61.044-2.5004-7.967-4.24204-16.072-4.24204-16.072s6.03544-7.156 10.46714-9.208c4.4145-2.052 7.5357-2.242 7.5357-2.242L64.7787 177.5Z"
			clipRule="evenodd"
		/>
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="m115.356 170.947-19.6932 36.765m105.3952-57.441.863 37.368m-142.9022 1.726 5.4491-11.278-.069.155"
		/>
		<path
			stroke="#303CF6"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.88976"
			d="M10.2356 153.548s5.3801-8.57 10.6396-11.553c5.2594-2.984 8.7944-3.553 8.7944-3.553m-19.1059 5.708 2.0003 6.07m.5688-8.639 2.1555 5.018m1.0345-7.743 2.2934 4.725m1.2932-6.794 2.1728 4.553m1.4144-5.812 2.4831 4.035M126.15 109.541c9.484.724 39.386 1.069 45.318-6.104"
		/>
		<defs>
			<linearGradient id="a" x1="98.0924" x2="124.633" y1="59.1859" y2="257.999" gradientUnits="userSpaceOnUse">
				<stop stopColor="#303CF6" />
				<stop offset="1" stopColor="#C0D2FF" />
			</linearGradient>
		</defs>
	</g>
);
